import ReactMarkdown from "react-markdown";

const ChatMessage = ({ text }) => {
  return (
    <div className="chat-response">
      <ReactMarkdown>{text}</ReactMarkdown>
    </div>
  );
};

export default ChatMessage;

// import { useEffect, useState } from "react";
// import ReactMarkdown from "react-markdown";

// const TYPING_SPEED = 20;

// const ChatMessage = ({ text = "" }) => {
//   const [displayedText, setDisplayedText] = useState("");

//   useEffect(() => {
//     let index = 0;
//     setDisplayedText("");

//     const interval = setInterval(() => {
//       index++;
//       setDisplayedText(text.slice(0, index));

//       if (index >= text.length) {
//         clearInterval(interval);
//       }
//     }, TYPING_SPEED);

//     return () => clearInterval(interval);
//   }, [text]);

//   return (
//     <div className="chat-response">
//       <ReactMarkdown>{displayedText}</ReactMarkdown>
//     </div>
//   );
// };

// export default ChatMessage;
